import { styled } from '@mui/system';

export const SectionWrapper = styled('div')`
    text-align: center;
    font-size: 0;
    position: relative;
    // padding-top:10px;
    p {
        font-size: 1.1rem;
        margin: 0;
    }
    h2 {
        font-weight: 700;
    }
    .background-img{
        position: absolute;
        right: 0;
        top: 0;
    }

    @media (max-width: 991px) {
        p {
            text-align: center;
        }
        .background-img{
           display:none;
        }
    }
`

export const IntroSection = styled('div')`
    background-color:${({ color }) => color};
    padding:20px 0;
    position: relative;
    z-index: 0;
    h4{
        font-size: 23px;
        font-family: "benton-sans",sans-serif;
        font-weight: 500;
        font-style: italic;
        color:#2372b9;
    }

    img {
        max-width: 100%;
    }
    button{
        color: #F37C27;
        text-decoration: underline;
        margin-top: 30px;
        font-size: 1.5rem;

        :hover {
            color:#2B3462;
        }
    }
    .tick_grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        justify-items: stretch;
        align-items: stretch;
        margin: 0 auto;
        max-width: 600px;
    }
    @media (max-width: 991px) {
        .tick_grid {
            grid-template-columns: 1fr !important;
            gap: 16px;
            max-width: 100%;
        }
        p {
            text-align: center;
        }
        button {
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
    }
`

export const ContentSection = styled('div')`
    padding:35px 0;
    img{
        max-width:100%;
        margin-bottom:30px;
        max-height:367px;
    }
    h2{
        font-size: 32px;
        font-family: "benton-sans",sans-serif;
        font-weight: 500;
        color: #2372b9
    }
    h4{
        font-size: 23px;
        font-family: "benton-sans",sans-serif;
        font-weight: 500;
        font-style: italic;
        color:#2372b9 !important;
    }
    p{
        font-size:20px;
        text-align:left;
        color:#333;
        line-height:1.5;
        margin-bottom:1.5em;
    }
    a{
        color:#2372b9 !important;
        text-align:left;
        cursor:pointer;
      }
      a:hover{
          outline:0;
          text-decoration:none;
          color:#f47b27 !important;
      }
    @media (max-width: 991px) {
        p {
            text-align: center;
        }
    }
    @media (min-width: 1200px) {
        
    }
`

export const TickSection = styled('div')`
    height: auto;
    padding: 20px 15px;
    border-radius: 15px;
    background: #12385D;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    h3, p {
        color: #fff;
        text-align: center;
    }
    p {
        font-size: 0.9rem;
        line-height: 1.4;
        margin: 0;
    }
    h3 {
        margin-bottom: 15px !important;
        font-size: 1.4rem;
        margin-top: 0;
    }
    img {
        width: 50px;
        margin-bottom: 15px;
    }

    @media (max-width: 768px) {
        padding: 24px 20px;
        margin-bottom: 20px;
        
        h3 {
            font-size: 1.6rem;
            margin-bottom: 20px !important;
        }
        
        p {
            font-size: 1rem;
        }
        
        img {
            width: 60px;
            margin-bottom: 20px;
        }
    }
`

export const HomeIntroSection = styled('div')`
    background-color:#2B3462;
    padding:15px 0;
    .MuiContainer-root{
        display:flex;
        align-items:center;
        justify-content:flex-start;
    }
    img {
        height:120px;
        margin-right:50px;
    }
    @media (max-width:768px){
        margin-bottom:1em;
        .MuiContainer-root{
            flex-direction:column;
            justify-content:center;
        }
        img {
            height:120px;
            margin-right:0;
        }
    }
`

export const HomeIntroContentSection = styled('div')`
    border-left:2px solid #FFF;
    padding:30px 40px;
    height:100%;
    p{
        font-size:1.3rem !important;
        color:#ECEDF1;
        text-align:left;
        :first-of-type {
            color:#E0863A;
            font-weight:600;
        }
    }
    strong {
        color:#fff;
    }

    @media (max-width:768px){
        border-left:none;
        padding:10px;
        p{
            text-align:center;
            font-size:1rem !important;
        }
    }
`

export const ChoiceSection = styled('div')`
    background-color:#EBF1F6;
    padding:50px 0;

    button {
        color: #F37C27;
        text-decoration: underline;
        margin-top: 30px;
        font-size: 1.5rem;

        :hover {
            color:#2B3462;
        }
    }

    .default-button {
        background: #F37C27 !important;
        text-decoration: none;
        margin-top: 30px;
        font-size: 1.5rem;
        color: #fff;

        :hover {
            color: #fff !important;
            background:#2B3462 !important;
        }
    }
`

export const EvaluateSection = styled('div')`
    background-color:#fff;
    padding:50px 0;
`

export const SwiperSection = styled('div')`
    max-width:80%;
    margin-left:auto;
    margin-right:auto;
    margin-top:50px;
    position :relative;

    @media (max-width :991px) {
        max-width:100%;
    }
`
export const SavingFontSection = styled('div')`

`

export const ZipcodeSection = styled('div')`
    background: #6BA543;
    padding: 20px;
    border-radius: 5px;
    p {
        font-size: 1.1rem;
        color: #fff;
        margin-bottom: 10px;
    }

    button {
        color: #fff;
        background: #F47B27;
        border-radius: 4px;
        margin-left: 1rem;
        padding: 12px 32px;
    }
    input:focus {
        box-shadow: none;
    }
    input:disabled {
        background: #fff;
    }
    button:disabled {
        background: #F47B27 !important;
    }
    .input-group-text {
        background: #fff;
    }

    @media (max-width: 768px) {
        button {
            padding: 12px 16px !important;
            margin-left: 0;
            margin-top: 1rem;
        }
       
    }
`

interface IntroContentProps {
    marginTop?:string;
}

export const IntroContentSection = styled('div')<IntroContentProps>`
    background:#2B3462; 
    border-radius: 30px;
    padding: 60px 20px;
    height: auto;
    margin-top: ${({marginTop} :IntroContentProps)=> marginTop ? marginTop : 0};
    min-height: 300px;
    width: 100%;

    p, h2 {
        color: #fff;
    }

    h2 {
        font-size: 2.2rem;
        margin-bottom: 20px;
        line-height: 1.2;
    }

    p {
        font-size: 1.1rem;
        line-height: 1.6;
    }

    @media (max-width: 991px) {
        margin-top: 0;
        padding: 40px 20px;
        min-height: 250px;
    }

    @media (max-width: 768px) {
        padding: 30px 16px;
        min-height: 200px;
        border-radius: 20px;
        
        h2 {
            font-size: 1.8rem;
            margin-bottom: 16px;
        }
        
        p {
            font-size: 1rem;
        }
    }
`

export const TickGrid = styled('div')`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;

    @media (max-width: 991px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0;
        width: 100%;
    }
`